import FormInputAntd from "components/FormInputAntd"

const AddressForm: React.FC = () => {
	return (
		<div className="py-5">
			<form>
				<FormInputAntd type="text" label="Address" name="address" />
			</form>
		</div>
	)
}

export default AddressForm
